import { call, select } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { AxiosRequestConfig } from 'axios'
import { TState } from 'redux/config/root-types'

const { download } = RequestMethods()

type TGetUsersFilters = {
  hideStaff: boolean
  hideDeleted: boolean
  fromDate?: string
  toDate?: string
}

export default function* SagaWorker_GetUsersXlsx() {
  const getFilter = (state: TState) => state.users.filter
  const filter: ReturnType<typeof getFilter> = yield select(getFilter)

  const formData: TGetUsersFilters = {
    hideStaff: true,
    hideDeleted: true,
    fromDate: filter.fromDate ? filter.fromDate : undefined,
    toDate: filter.toDate ? filter.toDate : undefined,
  }

  const config = {
    responseType: 'blob',
  } as AxiosRequestConfig

  try {
    yield call(async () => download('/users/report/xlsx', formData, config, 'users.xlsx'))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  }
}
